$(document).ready(function () {

    $(document).on('panel-form-ajax-success', '.js_orders-from', eventOrdersForm);
    $(document).on('panel-form-ajax-error', '.js_orders-from', eventOrdersForm);
    $(document).on('click', '.js_orders-client-search', getClientInfo);
    $(document).on('click', '.js_orders-toTour', toTour);
    $(document).on('click', '.seat:not(.reserved)', toggleSeat);
    $(document).on('change', '.js_orders-count_places', updateFormSeatActive);
    $(document).on('change', '.js_orders-count_places', calculateOrder);
    $(document).on('click', '.js_orders-to-tours', toTours);
    $(document).on('click', '.js_orders-get-check', getCheck);
    $(document).on('click', '.js_orders-completed', orderCompletedType);
    $(document).on('click', '.js_orders-completed_continue', orderCompletedContinueType);
    $(document).on('click', '.js_orders-completed_return', orderCompletedReturnType);
    $(document).on('click', '.js_order_calculation', orderCalculation);
    $(document).on('click', '.js_order_save', orderSave);
    $(document).on('click', '.js_order-cancel', checkOrder);
    $(document).on('click', '.js_orders-selection-places', orderSelectionPlaces);
    $(document).on('click', '.js_delete_confirm', deleteConfirm);
    $(document).on('click', '.js_presence', setPresence);
    $(document).on('change', '.js_admin_orders-count_places_child', setChild);
    $(document).on('change', '.js_admin_orders-count_places_child', calculateOrder);
    $(document).on('change', '.js_set_station_from', setNewStation);
    $(document).on('change', '.js_station_to_filter', ChangeToStation);
    $(document).on('change', '.js_orders-client-status_is', setNewStatus);
    $(document).on('change', '#country', maskPhone);
    $(document).on('click', '.save_order_places', SaveOrderPlaces);
    $(document).on('click', '.save_order', SaveOrder);
    $(document).on('focusout', '.js_input_order_places', SaveOrderPlacesData);
    $(document).on('change', '.js_datepicker_order_places', SaveOrderPlacesData);
    $(document).on('change', '.js_order-type-ticket', SaveOrderPlacesData);
    $(document).on('pjax:beforeSend', checkOrder);
    $(document).on('multiple-added', '.js_reindex-baggage', window.reindexBlocks('baggage', ['length', 'width', 'height'], '', ['']));
    $(document).on('multiple-removed', window.reindexBlocks('baggage', ['length', 'width', 'height'], '', ['']));
    $(document).on('change', '.js_select_station-type_from, .js_select_station-type_to', selectOrderStationTypeChange);


    if (!$('#phone').val()) {
        $("#station_from_id, #station_to_id").prop('disabled', true);
        if ($('#suggest_from').length && $('#suggest_to').length) {
            $("#suggest_from, #suggest_to").prop('disabled', true);
        }
    } else {
        $("#station_from_id, #station_to_id").tooltip('disable');
    }

    function orderCalculation() {
        $('#save_data_flag').val(0);
        $('.js_orders-type').val('no_completed');
    }

    function orderSave() {
        $('#save_data_flag').val(1);
        $('.js_orders-type').val('no_completed');
        $(this).hide();
    }

    function ChangeToStation() {
        document.getElementById('changed_places_count').innerText = "1"; //для поместного бронирования без это не меняется блок с информацией по пассажирам
        $('.wrapper-spinner').show();
        checkStation('to');
    }

    function checkStation(destination) {
        var data = {
            tour_id: $("input[name='tour_id']").val(),
            station_from_id: $("#station_from_id").val(),
            station_to_id: $("#station_to_id").val() ? $("#station_to_id").val() : $("#station_to_id").find('option[selected]').attr('value'),
            count_places: $("#count_places").val(),
            order_id: $('.js_orders-id').val(),
            order_slug: $('.js_orders-slug').val(),
            status: $('#status').val(),
            destination: destination,
        };

        if (data['station_to_id'] !== undefined) {
            $.get('/admin/orders/check_stations', data, (response) => {
                $('.wrapper-spinner').hide();
                if (response.result === 'error') {
                    $('.ibox-footer').hide();
                    toastr.error(response.message);
                } else {
                    $('#BusLayout').html(response.bus_tour);

                    selectOrderStationType();

                    if ($('.js_orders-client-phone').inputmask("isComplete")) {
                        $(".js_order_calculation").parent().parent().submit();
                        $('.ibox-footer').show();
                        toastr.success(response.message);
                    }
                }
            });
        } else {
            toastr.error('Нету доступных "Мест высадки". Изменен типа "Места высадки".');
            $('.wrapper-spinner').hide();

            let className = 'js_select_station-type_to',
                self = $('.' + className + ':checked'),
                select = $('.' + className.replace('-type', '')),
                isDefault = parseInt(self.val()) - 1;

            select.find('option').prop('disabled', 1);
            self.prop('checked', 0);
            $('.' + className + '[value="' + (!isDefault + 1) + '"]').prop('checked', 1);
            $('.' + className).trigger('change');
        }
    }

    function selectOrderStationType() {
        let filters = [
            $('.js_select_station-type_from:checked'),
            $('.js_select_station-type_to:checked')
        ];

        if (filters[0].length && filters[1].length) {
            $.each(filters, function () {
                let self = $(this),
                    className = self.attr('class'),
                    select = $('.' + className.replace('-type', '')),
                    isDefault = parseInt(self.val()) - 1;

                select.find('option').each(function () {
                    let self = $(this);

                    self.data('is_default') ? self.prop('disabled', !isDefault) : self.prop('disabled', isDefault);
                });

                $('.' + className.replace('-type', '-parameter')).val(isDefault);

                select2Init(select);
            })
        }
    }

    function selectOrderStationTypeChange() {
        let self = $(this),
            className = self.attr('class'),
            select = $('.' + className.replace('-type', '')),
            isDefault = parseInt(self.val()) - 1;

        if (select.find('option[disabled]').length) {
            select.find('option').prop('selected', false);
            let option = (className.indexOf('station-type_to') !== -1) ? select.find('option[disabled]').last() : select.find('option[disabled]').first();
            option.prop('disabled', 0);
            option.prop('selected', 1);
            select.trigger('change');
        } else {
            toastr.error('Нету доступных "Мест высадки".');
            self.prop('checked', 0);
            $('.' + className + '[value="' + (!isDefault + 1) + '"]').prop('checked', 1);
        }
    }

    function select2Init(select) {
        select.select2({
            width: "100%",
            sorter: data => data.sort((a, b) => a.text.localeCompare(b.text))
        }).on('select2:unselecting', function () {
            $(this).data('unselecting', true);
        }).on('select2:opening', function (e) {
            if ($(this).data('unselecting')) {
                $(this).removeData('unselecting');
                e.preventDefault();
            }
        });
    }

    function getCheck() {
        let url = $(this).data('url');

        $.get(`${url}`, (response) => {
            if (response.result == 'success') {
                toastr.success(response.message);
                window.open(response.link, '_blank').focus();
            } else {
                toastr.error(response.message);
            }
        })
    }

    function SaveOrderPlaces() {
        let order_id = $(this).data('order_id');
        let el = '#order_places-' + order_id;
        let url = $(this).data('url');
        let data = $(el + ' :input').serializeArray();
        $.post(url, data, function () {
            $('a[data-target="#order-' + order_id + '"]').click();
            toastr.success('Данные сохранены!');
        });
    }

    function SaveOrder() {
        let order_id = $(this).data('order_id');
        let el = '#' + order_id;
        let url = $(this).data('url');
        let data = $(el + ' :input').serializeArray();
        $.post(url, data, function () {
            $('a[data-target="#order_places-' + order_id + '"]').click();
            toastr.success('Данные сохранены!');
        });
    }

    function SaveOrderPlacesData() {
        let order_id = $('.js_div_order_places').data('order_id');
        let url = $('.js_div_order_places').data('url');
        let data = $('.js_div_order_places :input').serializeArray();
        $.post(url, data);
    }

    function setNewStatus() {
        if (confirm("Вы подтверждаете изменение?")) {
            const status_id = $(this).val();
            const url = $(this).data('url');
            const id = $('input[name=client_id]').val();
            $(this).data("current", $(this).val());

            if (id) {
                $('.wrapper-spinner').show();
                $.get(url + '?id=' + id + '&status_id=' + status_id, (response) => {
                    $('.wrapper-spinner').hide();
                    $(".js_order_calculation").click();
                    toastr.success('Социальный статус успешно обновлён');
                })
            } else {
                toastr.warning('Клиент не загружен');
            }

            return true;
        } else {
            $(this).val($(this).data('current'));

            return false;
        }
    }

    function setNewStation() {
        let $this = $(this);
        let url = $this.data('url');
        let route_id = $this.data('route_id');
        let station_from_id = $this.val();
        let station_to_id = $this.data('station_to_id');
        let selectEl = $('#station_to_id');
        let selectedValue = selectEl.val();
        if (selectEl.is('select')) {
            $('.wrapper-spinner').show();
            $.get(url + '?route_id=' + route_id + '&station_from_id=' + station_from_id + '&station_to_id=' + station_to_id, (response) => {
                selectEl.html(response);
                selectEl.val(selectedValue);
                checkStation('from');
            })
            document.getElementById('changed_places_count').innerText = "1"; //для поместного бронирования без это не меняется блок с информацией по пассажирам
        }
    }

    function orderSelectionPlaces() {
        let $this = $(this)
        let url = $this.data('url');
        $.get(url, (response) => {
            if (response.result == 'success') {
                $('.js_orders-left').html(response.html)
                $('.js_orders-places_with_number').val(1)
                $this.remove()
                updateFormSeatActive()
            }
        })
        return false;
    }

    function setChild() {
        let url = $(this).data('url');
        let order_id = $(this).data('order_id');

        let $prices = $('.js_admin_price_places');
        let count = $(this).val();
        $('.js_input_order_places').first().trigger('focusout');
        $.get(`${url}?count=${count}&order_id=${order_id}`, (response) => {
            if (response.result == 'success') {
                toastr.success(response.message);
            } else {
                toastr.error(response.message);
            }
            $prices.html(response.view);
        })
    }

    function orderCancel(el) {
        let id = $(el).data('id');
        if (id == undefined || !id) {
            return;
        }
        let url = $(el).attr('href') + '?id=' + id;
        $.get(url, (response) => {
            if (response.result == 'success') {
                window.showNotification(response.message, 'error')
                if ($(el).data('cancel_button')) {
                    history.back();
                } else {
                    return true;
                }
            }
        })
        return false;

    }

    function calculateTimeAndMinute(date){
        var currentTime = new Date();  
        var otherTime = new Date(date); 
        let diffMs = otherTime - currentTime;
        
        if (diffMs>0) {
            let hours = Math.floor(diffMs / (1000 * 60 * 60)); 
            let minutes = Math.round((diffMs % (1000 * 60 * 60)) / (1000 * 60)); 
            return {'hours':hours, 'minutes':minutes};
        }
        return "";
    }
    const { DateTime } = require('luxon');
    function formatDateWithLuxon(dateString) {
        const formattedDateString = dateString.replace(' ', 'T') + 'Z'; 
        const date = DateTime.fromISO(formattedDateString, { zone: 'utc' });
        const minskTime = date.setZone('Europe/Minsk');
        return minskTime.toFormat('yyyy-LL-dd HH:mm'); 
    }
    function deleteConfirm(e) {
        
        var $link = $(this);
        var info="";
        var order =$link.data('order');
        var route =$link.data('route');
        var dateTimeString = order.from_date_time.split('T')[0] + ' ' + order.from_date_time.split('T')[1].split(".")[0];
        var formattedDate = formatDateWithLuxon(dateTimeString);   
        var cancelled = route.cancelled_tariff;
        var rate_cost = cost_type = total = 0;

        if (cancelled) {
            var hours_min = "";            
            
            var h_m = calculateTimeAndMinute(order.tour.date_time_start);            
            if (cancelled.time_calculation==2) {
                 h_m = calculateTimeAndMinute(formattedDate);
            } 
         
            var rate =  cancelled.rates.filter(rate => h_m.hours >= rate.min_h && h_m.hours <= rate.max_h)[0];

            if (rate) {
                rate_cost =  rate.cost_type===0?rate.cost+"руб.":rate.cost+"%";
                cost_type = rate.cost_type===0?'В денежных единицах':'В процентах';
                total= rate.cost_type===0?rate.cost: order.price * rate.cost / 100;
            }            
            if(h_m.hours && h_m.minutes) {
                hours_min = h_m.hours+" ч. "+h_m.minutes+" мин.";
            } else if(h_m.hours && !h_m.minutes) {
                hours_min = h_m.hours+" ч. ";
            } else if(!h_m.hours && h_m.minutes) {
                hours_min = h_m.minutes+" мин.";
            }
            info="<div class='info-for-cancel row'><div class='col-sm-6'>"
            +"<p class='item'><span>Номер брони:</span><span>"+order.slug+"</span></p>"
            +"<p class='item'><span>Клиент:</span><span>"+order.client.first_name+" "+order.client.middle_name+" "+order.client.last_name+"</span></p>"
            +"<p class='item'><span>Телефон:</span><span>"+order.client.phone+"</span></p>"
            +"<p class='item'><span>Дата и время отправления:</span><span>"+formattedDate+"</span></p>"
            +"<p class='item'><span>Место посадки:</span><span>"+order.station_from.city.name+" "+order.station_from.name+"</span></p>"
            +"<p class='item'><span>Место высадки:</span><span>"+order.station_to.city.name+" "+order.station_to.name+"</span></p>"
            +"<p class='item'><span>Стоимость:</span><span>"+order.price+" руб.</span></p>"
            +"</div><div class='col-sm-6'>"
            +"<p class='item'><span>Направление:</span><span>"+order.tour.route.name+"</span></p>"
            +"<p class='item'><span>Рейс:</span><span>"+order.tour.date_time_start+"</span></p>"
            +"<p class='item'><span>Тип отмены:</span><span>"+order.tour.route.cancelled_tariff.name+"</span></p>"
            +"<p class='item'><span>Время до отправления:</span><span>"+hours_min+"</span></p>"
            +"<p class='item'><span>Удержание:</span><span>"+rate_cost+"</span></p>"
            +"<p class='item'><span>Тип удержания: </span><span>"+cost_type+"</span></p>"
            +"<p class='item'><span>Итого удержано: </span><span> "+total+" руб.</span></p>"
            +"</div></div>";
        }
       
        var dialog = bootbox.prompt({
            title: $link.data('title'),
            size: "large",
            inputType: 'select',
            inputOptions: [{
                text: 'Клиент отказался',
                value: ''
            },
            {
                text: 'Нет машины',
                value: '2'
            },
            {
                text: 'Нет водителя',
                value: '3'
            },
            {
                text: 'Форс мажор',
                value: '4'
            },
            {
                text: 'Тестовая бронь',
                value: '6'
            },
            ],
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> Отмена'
                },
                confirm: {
                    label: '<i class="fa fa-check"></i> OK'
                }
            },
            callback: function callback(result) {
                
                if (result !== null) {
                    result = result === '' ? '1' : result;
                    $.get($link.data('url') + '?reason=' + result+"&total="+total, function (response) {
                        if (response.result === 'success') {
                            $link.closest('tr').hide(2000);
                            if ($link.data('reload')) {
                                window.location.reload(false);
                            }
                        }
                        ;
                    });
                }
            }
        });
        if (info) {
            $(dialog).find('.bootbox-body').append(info);
            setTimeout(function () {
                $(".bootbox select").on('change', function (e) {
                    if($(this).val()){
                        $(".info-for-cancel").addClass('hide');
                    } else {
                        $(".info-for-cancel").removeClass('hide');
                    }
                });
            }, 300);
        }
        
        return false;
    }

    function setPresence(e) {
        var $link = $(this);
        var dialog = bootbox.prompt({
            title: $link.data('title'),
            size: "large",
            inputType: 'select',
            inputOptions: [{
                text: 'Явка',
                value: ''
            },
            {
                text: 'Неявка',
                value: '0'
            },
            {
                text: 'Не указано',
                value: '2'
            },
            ],
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> Отмена'
                },
                confirm: {
                    label: '<i class="fa fa-check"></i> OK'
                }
            },
            callback: function callback(result) {
                if (result !== null) {
                    result = result === '' ? '1' : result;
                    $.get($link.data('url') + '?presence=' + result, function (response) {
                        if (response.result === 'success') {
                            if ($link.data('reload')) {
                                window.location.reload(false);
                            }
                        }
                        ;
                    });
                }
            }
        });
        return false;
    }

    function orderCompletedType() {
        let hasErrors = false;
        const types = $('select[name*="doc_type"]:visible');
        const numbers = $('input[name*="doc_number"]:visible');

        for (let i = 1; i < types.length; i++) {
            const type = types[i];
            const number = numbers[i];
            if (type.value === '0' && (!number.value || number.value.replace(' ', '').length != 10)) {
                $(number).parent().parent().addClass('has-error');
                hasErrors = true;
            } else {
                $(number).parent().parent().removeClass('has-error');
            }
        }
        if (hasErrors) {
            toastr.error('Не все номера удостоверения личности заполнены корректно');
            return;
        }
        
        $(this).addClass('click');
        let $type = $('.js_orders-type');
        $type.val($(this).data('type'))
        $('#save_data_flag').val(1);
        $('.js_orders-from').trigger('submit');
    }

    function orderCompletedContinueType() {
        if ($('.js_orders-client-phone').val().length > 10) {
            let location_href = $(this).data('url') + '?incomming_phone=' + $('.js_orders-client-phone').val();
            $(this).addClass('click');
            let $type = $('.js_orders-type');
            $('#save_data_flag').val(1);
            $type.val($(this).data('type'))
            $('.js_orders-from').ajaxSubmit({
                success: function success(data) {
                    if (data.id !== undefined) {
                        changePlaceIds(data)
                        window.location.href = location_href;
                    } else {
                        toastr.error('Не заполнены все обязательные поля!');
                    }
                }
            });
        } else toastr.error('Не заполнен номер телефона');
    }

    function orderCompletedReturnType() {
        if ($('.js_orders-client-phone').val().length > 10) {
            var location_href = $(this).data('url') + '?incomming_phone=' + $('.js_orders-client-phone').val();
            $(this).addClass('click');
            var $type = $('.js_orders-type');
            $type.val($(this).data('type'));
            $('#save_data_flag').val(1);
            $('.js_orders-from').ajaxSubmit({
                success: function success(data) {
                    if (data.id !== undefined) {
                        changePlaceIds(data)
                        window.location.href = location_href + '&order_return=' + data.id;
                    } else {
                        toastr.error('Не заполнены все обязательные поля!');
                    }
                }
            });

        } else toastr.error('Не заполнен номер телефона');

    }

    function toggleSeat() {
        let phone = $('.js_orders-client-phone').val();
        let firstName = $('.js_orders-client-first_name').val();
        if (phone.replace(/\D/g, '').length > 10 && firstName) {
            $(this).toggleClass('active')
            updateFormSeatActive()
            document.getElementById('changed_places_count').innerText = "1"; //для поместного бронирования без это не меняется блок с информацией по пассажирам
            $('.js_orders-from').submit()
        } else {
            window.showNotification('Введите сперва номер телефона и имя', 'error');
        }
    }

    function eventOrdersForm(e, response) {
        if (response.result == 'success' && $('.js_orders-type').val() == $('.js_orders-completed').data('type') && $('.js_orders-completed').hasClass('click')) {
            setTimeout(() => $('.js_form-ajax-back').click(), 500);
            delete response.view_tour;
        } else {
            $('.js_orders-completed').removeClass('click')
        }

        if (response.id) {
            $('.js_orders-slug').val(response.slug);
            if (response.save_data === '1') {
                $('.js_orders-id').val(response.id);
            }

            toastr.success('Номер брони ' + response.slug);

            if (!$('.js_order-old-places').length) {
                $('.js_order-cancel').data('id', response.id).removeClass('hidden');
                let el = $('.js_order_save');
                if (el.length) {
                    el.removeClass('hidden');
                }
            }
        }
        let needsUpdateElement = document.getElementById('changed_places_count');
        if ($('#save_data_flag').val() == "1") {
            changePlaceIds(response)
        }
        if (response.view_tour && needsUpdateElement.innerText === "1") {
            needsUpdateElement.innerText = "0";
            $('.js_orders-left').html(response.view_tour);
            $('.js_input_order_places').first().trigger('focusout');
        }
        ;
        if (response.result == 'error') updateFormSeatActive()

    }

    function changePlaceIds(response) {
        //техника подмены id-шек
        let curIdIndex = 0;
        $('.js_div_order_place').each(function () {
            $(this).find('input, select').each(function () {
                let inputName = $(this).attr('name');
                if (inputName.includes('[')) {
                    let fieldName = inputName.split(']')[1].slice(1);
                    if (response.places_id && curIdIndex < response.places_id.length) {
                        $(this).attr('name', `order_places[${response.places_id[curIdIndex]}][${fieldName}]`);
                    }
                }
            });
            curIdIndex++;
        });
        SaveOrderPlacesData();
    }

    function toTours() {
        let url = $(this).data('url');
        let buttonSave = $('.js_order_save');
        $.get(url, (response) => {
            if (response.result == 'success') {
                $('.js_orders-left').html(response.html)
                $('.js_orders-filter').html(response.filter)
                window.init()
            } else if (buttonSave.length) {
                buttonSave.click();
                $('.js_orders-to-tours').click();
            }
        })
    }

    function toTour() {
        let phone = $('input[name=phone]').val();
        let city_from_id = $(this).data('city_from_id');
        let city_to_id = $(this).data('city_to_id');
        let url = $(this).data('url') + '?phone=' + phone + '&city_from_id=' + city_from_id + '&city_to_id=' + city_to_id + '&with_phone=' + Number(phone.length === 0);
        $.get(url, (response) => {
            if (response.result == 'success') {
                $('.js_orders-filter').html('')
                $('.js_orders-left').html(response.html)
                $('.js_orders-tour-info').html(response.tour_info)
                $('.js_orders-client-info').html(response.viewClientInfo)
                $('.js_orders-tour_id').val(response.tour_id)
                updateFormSeatActive();

                if (response.clientPhone) {
                    $('#country').val(response.clientPhone);
                    switchCountry(response.clientPhone);
                }
            }
        })
    }

    function maskPhone() {
        var country = $('#country option:selected').val();
        switchCountry(country);
    }

    function switchCountry(country) {
        switch (country) {
            case "us":
                $("#phone").inputmask("+1 (999) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "gr":
                $("#phone").inputmask("+30 (999) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "nl":
                $("#phone").inputmask("+31 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "be":
                $("#phone").inputmask("+32 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "fr":
                $("#phone").inputmask("+33 (999) 99-99-99", { 'oncomplete': getClientInfo });
                break;
            case "es":
                $("#phone").inputmask("+34 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "ie":
                $("#phone").inputmask("+353 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "mt":
                $("#phone").inputmask("+356 (99) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "fi":
                $("#phone").inputmask("+358 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "bg":
                $("#phone").inputmask("+35\\9 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "hu":
                $("#phone").inputmask("+36 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "lt":
                $("#phone").inputmask("+370 (999) 99-999", { 'oncomplete': getClientInfo });
                break;
            case "lv":
                $("#phone").inputmask("+371 (999) 99-9-99", { 'oncomplete': getClientInfo });
                break;
            case "ee":
                $("#phone").inputmask("+372 (99) 99-999", { 'oncomplete': getClientInfo });
                break;
            case "md":
                $("#phone").inputmask("+373 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "by":
                $("#phone").inputmask("+375 (99) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "ua":
                $("#phone").inputmask("+380 (99) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "it":
                $("#phone").inputmask("+3\\9 (999) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "ch":
                $("#phone").inputmask("+41 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "cz":
                $("#phone").inputmask("+420 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "sk":
                $("#phone").inputmask("+421 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "au":
                $("#phone").inputmask("+43 (999) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "gb":
                $("#phone").inputmask("+44 (999) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "dk":
                $("#phone").inputmask("+45 (999) 99-9-99", { 'oncomplete': getClientInfo });
                break;
            case "se":
                $("#phone").inputmask("+46 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "no":
                $("#phone").inputmask("+47 (999) 99-9-99", { 'oncomplete': getClientInfo });
                break;
            case "pl":
                $("#phone").inputmask("+48 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "de":
                $("#phone").inputmask("+4\\9 (999) 999-999-99", { 'oncomplete': getClientInfo });
                break;
            case "ru":
                $("#phone").inputmask("+7 (999) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "tr":
                $("#phone").inputmask("+\\90 (999) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "ae":
                $("#phone").inputmask("+\\971 (9)9-999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "il":
                $("#phone").inputmask("+\\972 (99) 999-99-99", { 'oncomplete': getClientInfo });
                break;
            case "tj":
                $("#phone").inputmask("+\\9\\92 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "tm":
                $("#phone").inputmask("+\\9\\93 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "az":
                $("#phone").inputmask("+\\9\\94 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "ge":
                $("#phone").inputmask("+\\9\\95 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "kg":
                $("#phone").inputmask("+\\9\\96 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
            case "uz":
                $("#phone").inputmask("+\\9\\98 (999) 999-999", { 'oncomplete': getClientInfo });
                break;
        }
    }

    //$('#phone').change(getClientInfo);

    maskPhone();

    // маска на Паспорт гражданина РФ
    function setMasksIfPassport(e = null) {
        const selects = document.querySelectorAll('select');
        const inputs = document.querySelectorAll('input');

        $selects = [];
        $inputs = [];
        
        selects.forEach(select => {
            if (!select.name.includes('doc_type') && !select.name.includes('doc_type')) {
                return;
            }
            $selects.push($(select));
        });

        inputs.forEach(input => {
            if (!input.name.includes('doc_number') && !input.id.includes('doc_number')) {
                return;
            }
            $inputs.push($(input));
        });

        for (let i in $selects) {
            $select = $selects[i];
            $input = $inputs[i];
            
            console.log($select.val(), $select[0])
            if ($select.val() === "0") {
                if ($input.hasClass('passport_mask')) continue;
                
                let setValue = ''
                if (!$input.hasClass('value_is_set')) {
                    setValue = $input.val();
                    $input.addClass('value_is_set');
                }
                
                $input.addClass('passport_mask');
                
                $input.inputmask("9999 999999", {
                    placeholder: "",
                    showMaskOnHover: false,
                    showMaskOnFocus: false,
                    clearIncomplete: false,
                    autoUnmask: true,
                });
                
                $input.val(setValue);
                $input.attr('last_type', '0');                
            } else {
                if ($input.hasClass('passport_mask')) {
                    $input.removeClass('passport_mask');
                    $input.inputmask('remove');
                }
                
                if ($input.attr('last_type') && $input.attr('last_type') != $select.val()) {
                    $input.val('');
                }
                $input.attr('last_type', $select.val());
            }
        }
    }
    
    $('body').on('change', 'select', setMasksIfPassport);
    setMasksIfPassport();
    setTimeout(setMasksIfPassport, 500);

    $('select[id*="-country_id"]').select2();
    
    function getClientInfo() {
        let tour_id = $('input[name=tour_id]').val();
        let $this = $('.js_orders-client-phone');
        let url = $this.data('url-client-info');
        let phone = $this.val();
        $.get(`${url}`, {'phone': phone, 'tour_id': tour_id}, (response) => {
            $('.js_orders-client-info').html(response.viewClientInfo);
            $('.js_orders-client-status_is').val(response.status_id);

            $('.js_orders-client-date_social').val(response.date_social);
            $('.js_transfer_street').val(response.last_address.street);
            $('.js_transfer_house').val(response.last_address.house);
            $('.js_transfer_building').val(response.last_address.building);
            $('.js_transfer_apart').val(response.last_address.apart);
            $('.js-taxi-history').on('change', function () {
                $('#suggest_from').val($(this).find(':selected').data('from'));
                $('#suggest_to').val($(this).find(':selected').data('to'));
            });
            $("#station_from_id, #station_to_id").prop('disabled', false).tooltip('disable');
            if ($('#suggest_from').length && $('#suggest_to').length) {
                $("#suggest_from, #suggest_to").prop('disabled', false);
            }
            if ($("#station_from_id").val()) {
                if ($('.js_set_station_from').length && $('.js_station_to_filter').length) {
                    $('.js_set_station_from').trigger('change');
                } else {
                    ChangeToStation()
                }
            } else {
                $(".js_order_calculation").submit(); //Для рейсов в режиме такси
            }

            setMasksIfPassport();
            $("#doc_number").val(response.doc_number);

            if (typeof init == 'function') init();
            window.showNotification(response.message, response.type);
        })
    }

    function initOrderClientPhone() {
        if ($('#country').val()) {
            switchCountry($('#country').val());
        } else {
            $("#country").val(InputCodeValue);
            switchCountry(InputCodeValue);
        }
    }

    function updateFormSeatActive() {
        let $wrapper = $('.js_orders-places-input');
        $wrapper.html('');
        let $countPlaces = $('.js_orders-count_places');
        if ($countPlaces.length) {
            let val = $countPlaces.val();
            for (let $i = 0; $i < val; $i++) {
                $wrapper.prepend(`<input type="hidden" name="places[]" value="" data-number=""/>`);
            }
        } else {
            $('.seat.active:not(.reserved)').each(function () {
                let number = $(this).data('number');
                $wrapper.prepend(`<input type="hidden" name="places[]" value="${number}" data-number="${number}"/>`);
            })
        }
    }

    function calculateOrder() {
        document.getElementById('changed_places_count').innerText = "1";
        document.querySelector('.js_order_calculation').click();
    }

    initOrderClientPhone();
    window.initOrderClientPhone = initOrderClientPhone;


    function checkOrder() {
        if ($('.js_orders-id').val() && $('.js_orders-type').val() === 'no_completed') {
            if ($(this).hasClass('js_order-cancel')) {
                $this = $(this);
                $this.data('cancel_button', true);
            } else {
                $this = $('.js_order-cancel').first();
                $this.data('cancel_button', false);
            }
            let id = $this.data('id');
            let text = "Бронь не будет сохранена. Покинуть страницу?";
            if (id !== undefined) {
                text = "Бронь будет удалена. Покинуть страницу?"
            }
            if (confirm(text)) {
                orderCancel($this);
                return true;
            } else {
                $('.wrapper-spinner').hide();
                return false;
            }
        }
    }

    jQuery('#country_id').select2();
});

